import _ from 'lodash'
import { EntityState } from '@reduxjs/toolkit'
import { CommonState, Model } from '@/core/classes/Model'
import { SearchRequestOptions } from '@/core/types/request'

export type Medecin = {
  active: boolean
  gender?: 'M' | 'F' | 'I'
  name: string
  surname: string
  phone?: string
  email: string
  cp?: string
  mssante?: string
  cps: string
  speciality?: string
  status: 'MEDECIN' | 'PDS'
  street?: string
  city?: string
}

export type MedecinState = CommonState & {
  medecins: EntityState<Medecin, string>
}

class MedecinModel extends Model {
  static instance: MedecinModel

  static getInstance() {
    if (!MedecinModel.instance) {
      MedecinModel.instance = new MedecinModel('medecin')
    }
    return MedecinModel.instance
  }

  getInitialState(): MedecinState {
    return _.merge({}, this.commonState, {
      medecins: {
        entities: {},
        ids: [],
      },
    })
  }

  // TODO: add type for query
  getMedecins = async (query: Record<string, any>, options?: SearchRequestOptions): Promise<[Medecin[], number]> => {
    const defaultOptions = {
      limit: 5,
      order: 'ASC',
      skip: 0,
      orderBy: 'name',
    }

    return await this.httpClient.request<[Medecin[], number]>('/v2/query', 'POST', { query, options: _.merge({}, defaultOptions, options) })
  }
}

export default MedecinModel.getInstance()
